import React from 'react';

import Breadcrumbs from '@sp/client/components/Breadcrumbs';
import NavBar from '@sp/client/components/NavBar';

import s from './style.less';
import Form from './form';

class ProviderNewPlan extends React.Component {
  breadcrumbs = [
    { name: 'Home', to: '/' },
    { name: 'Create A New Service Plan' },
  ];
  nav = [
    '1. Enter Car Details',
    '2. Get Quotes',
    '3. Create Plan and Documentation',
  ];

  render() {
    return (
      <NavBar withPadding>
        <Breadcrumbs paths={this.breadcrumbs} />
        <div className={s.page__title}>Create A New Service Plan</div>
        <ol className={s.nav}>
          {this.nav.map((n, key) => (
            <li key={key}>{n}</li>
          ))}
        </ol>
        <Form />
      </NavBar>
    );
  }
}

export default ProviderNewPlan;
